module.exports = __webpack_public_path__ + "static/media/18ECA22.b7829eb8.jpg";